import * as z from 'zod';

import { nullableBooleanQuerySchema, nullableNumericQuerySchema } from '@/_schemas/generic';

export const inventoryVolumeQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(1),
  quantity: nullableNumericQuerySchema(),
  primary: nullableBooleanQuerySchema(),
});

export type InventoryVolumeQueryLinkerSchema = z.infer<typeof inventoryVolumeQueryLinkerSchema>;
